<div class="wrapper flex flex-col justify-between">
  <div class="heading text-type-2 mb-[20px]">
    {{ item?.item_number || 'Item Detail' }}
  </div>

  <mat-tab-group class="contents-tab-group flex-1" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="selectedTabIndex = $event">
    <mat-tab label="Details">
      <div class="details-content pt-[20px]">
        <!-- Status -->
        <div class="row-details flex flex-col gap-[4px] mb-[20px]">
          <div class="label w-full">Status</div>
          <div class="value w-full">
            @if (item?.status && statusMap[item.status]) {
              <div
                [ngClass]="[statusMap[item.status].bgColor, statusMap[item.status].textColor]"
                class="status-chip px-[14px] rounded-full w-fit">
                {{ statusMap[item.status].label }}
              </div>
            }
          </div>
        </div>

        @if (item?.created_at) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Created</div>
            <div class="value w-full text-type-11">
              @if (item.createdBy) {
                {{ ((item.createdBy.first_name || '') + ' ' + (item.createdBy.last_name || '')).trim() || item.createdBy.email }} &middot;
              }
              {{ item.created_at | date:'MMM d, y' }}
            </div>
          </div>
        }

        @if (item?.punchlist?.name || data?.punchlist?.name) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Punch list</div>
            <div class="value w-full text-type-11">{{ item?.punchlist?.name || data?.punchlist?.name }}</div>
          </div>
        }

        @for (field of fields || []; track field.name) {
          @switch (field.name) {
            @case ('title') {
              <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                <div class="label w-full">{{ field.label || 'Title' }}</div>
                <div class="value w-full text-type-11">{{ item?.title || 'N/A' }}</div>
              </div>
            }
            @case ('description') {
              @if (item?.description) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Description' }}</div>
                  <div class="value w-full text-type-11">{{ item.description }}</div>
                </div>
              }
            }
            @case ('site_id') {
              @if (item?.site?.name) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Site' }}</div>
                  <div class="value w-full text-type-11">{{ item.site.name }}</div>
                </div>
              }
            }
            @case ('bid_items') {
              @if (item?.bid_items?.length) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || ('Bid Item' + (item.bid_items.length > 1 ? 's' : '')) }}</div>
                  <div class="selected-bid-item-list flex flex-col justify-center">
                    @for (bidItem of item.bid_items; track bidItem?.id) {
                      <div class="bid-item-id-details-container mb-[10px]">
                        <div class="bid-item-id-details text-type-11">
                          <div class="each-item flex justify-start items-center gap-[16px]">
                            <div class="left flex justify-start items-center">
                              <div class="icon-wrapper">
                                <mat-icon svgIcon="daily-report-page-menu-bid-item" />
                              </div>
                            </div>
                            <div class="right flex flex-col justify-center items-start">
                              <div class="bid-item-heading text-type-6">Bid item {{ bidItem?.item }}</div>
                              <div class="h-[1px]">&nbsp;</div>
                              <div class="description text-type-14">{{ bidItem?.description }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            }
            @case ('category') {
              @if (valuesText('category'); as categories) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Category' }}</div>
                  <div class="value w-full text-type-11">{{ categories }}</div>
                </div>
              }
            }
            @case ('type') {
              @if (valuesText('type'); as types) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Type' }}</div>
                  <div class="value w-full text-type-11">{{ types }}</div>
                </div>
              }
            }
            @case ('severity') {
              @if (item?.severity) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Severity' }}</div>
                  <div class="value w-full">
                    @if (severityMap[item.severity]) {
                      <div
                        [ngClass]="[severityMap[item.severity].bgColor, severityMap[item.severity].textColor]"
                        class="status-chip px-[14px] rounded-full w-fit">
                        {{ severityMap[item.severity].label }}
                      </div>
                    } @else {
                      <span class="text-type-11">{{ item.severity }}</span>
                    }
                  </div>
                </div>
              }
            }
            @case ('need_by_date') {
              @if (item?.need_by_date) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Need by date' }}</div>
                  <div class="value w-full text-type-11">{{ item.need_by_date | date:'MMM d, y' }}</div>
                </div>
              }
            }
            @case ('location_description') {
              @if (item?.location_description) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Location' }}</div>
                  <div class="value w-full text-type-11">{{ item.location_description }}</div>
                </div>
              }
              <!-- Design context (spec §12). No location slot here, so the card keeps the capture in its own tile. -->
              @if (item?.map_feature_link) {
                <app-design-context
                  class="block mb-[20px]"
                  data-testid="punchlist-item-detail-design-context"
                  [link]="item.map_feature_link"
                  [editable]="false"
                  [projectId]="data?.projectId"
                />
              }
            }
            @case ('proposed_solution') {
              @if (item?.proposed_solution) {
                <div class="row-details flex flex-col gap-[4px] mb-[20px]">
                  <div class="label w-full">{{ field.label || 'Proposed solution' }}</div>
                  <div class="value w-full text-type-11">{{ item.proposed_solution }}</div>
                </div>
              }
            }
          }
        }

        <!-- The design context is map data, not a config field: keep it when the project hides Location. -->
        @if (item?.map_feature_link && !showsField('location_description')) {
          <app-design-context
            class="block mb-[20px]"
            data-testid="punchlist-item-detail-design-context"
            [link]="item.map_feature_link"
            [editable]="false"
            [projectId]="data?.projectId"
          />
        }

        @if (item?.pictures?.length || item?.attachments?.length) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Attachments</div>
            <div class="pictures-row flex flex-wrap gap-[12px] mt-[8px]">
              @for (picture of (item?.pictures || []).concat(item?.attachments || []); track picture.id) {
                <div class="picture-block">
                  <app-image
                    (click)="appService.openCarousel($event, (item?.pictures || []).concat(item?.attachments || []), picture, false)"
                    [url]="picture.thumb_url || picture.original_url"
                    class="each-picture"
                  />
                </div>
              }
            </div>
          </div>
        }

        @if (issues.length) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full flex items-center gap-[8px]">
              Linked Issues
              <span class="linked-issues-count-badge">{{ issues.length }}</span>
            </div>
            <div class="linked-issues-list mt-[8px]">
              @for (issue of issues; track issue.id) {
                <div class="linked-issue-item flex flex-col gap-[4px] mb-[8px] cursor-pointer"
                     (click)="issue._expanded = !issue._expanded">
                  <div class="flex items-center justify-between">
                    <div class="text-type-11 font-medium">{{ issue.title }}</div>
                    <mat-icon class="expand-icon text-[#60698B]" style="font-size:18px;width:18px;height:18px">
                      {{ issue._expanded ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </div>
                  <div class="flex items-center gap-[8px] flex-wrap">
                    <span class="linked-issue-type-badge">{{ issue.type || 'Issue' }}</span>
                    <span class="linked-issue-status-badge">{{ issueStatusText(issue.status) }}</span>
                    <span class="text-type-14 text-[#60698B]">{{ issue.created_by_first_name }} {{ issue.created_by_last_name }}</span>
                  </div>
                  @if (issue._expanded) {
                    @if (issue.description) {
                      <div class="text-type-14 text-[#60698B] mt-[4px]">{{ issue.description }}</div>
                    }
                    @if (issue.pictures?.length) {
                      <div class="issue-pictures flex gap-[6px] mt-[6px] flex-wrap">
                        @for (pic of issue.pictures; track pic.id) {
                          <img [src]="pic.thumb_url || pic.original_url" class="issue-thumbnail" alt="Issue photo" />
                        }
                      </div>
                    }
                    @if (!issue.description && !issue.pictures?.length) {
                      <div class="text-type-14 text-[#60698B] mt-[4px] italic">No additional details</div>
                    }
                  }
                </div>
              }
            </div>
          </div>
        }

        @if (!readOnly && actionOptions.length) {
          <hr class="hr-line" />
          <app-dropdown
            data-testid="punchlist-action"
            [options]="actionOptions"
            [parentFormGroup]="actionForm"
            class="w-full mb-[20px]"
            controlName="action"
            placeholder="Take action on this item"
            label="actions"
          />

          <!-- Inputs come from the picked state's next-state formInputs -->
          @for (input of selectedInputs; track input.name) {
            @switch (input.type) {
              @case ('text[]') {
                <app-dropdown
                  [attr.data-testid]="'punchlist-action-input-' + input.name"
                  [enableSearch]="true"
                  [enableMultiple]="true"
                  [showCount]="true"
                  [selectionString]="'users'"
                  [options]="forwardCandidateOptions"
                  [parentFormGroup]="actionForm"
                  class="w-full mb-[20px]"
                  [controlName]="input.name"
                  [label]="input.label || input.name"
                  placeholder="Pick users"
                />
              }
              @case ('text') {
                <app-text-area
                  [attr.data-testid]="'punchlist-action-input-' + input.name"
                  [parentFormGroup]="actionForm"
                  class="w-full mb-[20px]"
                  [controlName]="input.name"
                  [label]="input.label || input.name"
                />
              }
            }
          }

          @if (hasFileInput()) {
            <app-pictures-section-with-tags
              data-testid="punchlist-action-input-attachments"
              (onDelete)="deleteActionPicture($event)"
              [add]="true"
              [pictures]="actionMediaFiles"
              [tags]="'actions-attachments'"
              class="pictures-section mb-[40px]"
              label="Attachments"
            />
          }
        }
      </div>
    </mat-tab>

    <mat-tab label="Discussion">
      <div class="discussion-content pt-[20px]">
        <!-- The timeline is shared with the issue contractor workflow -->
        <app-workflow-discussion [entries]="workflowHistory" recipientsLabel="Forwarded to" />
      </div>
    </mat-tab>
  </mat-tab-group>

  @if (!readOnly && actionOptions.length && selectedTabIndex === 0) {
    <div class="action-section mb-[5px] flex flex-row gap-[20px] w-full">
      <app-primary-button (handleClick)="executeAction()" [isDisabled]="!actionForm.get('action')?.value || acting" [isLoading]="acting" class="flex-1">
        Submit
      </app-primary-button>
    </div>
  }
</div>
